import {
  FeatureName,
  hasAssetAccess,
  isGuestWorkspaceRole,
  PermissionValues,
  useCurrentAccount,
  useIsFeatureEnabled,
  useRoles,
  type WorkspaceAsset,
} from '@gripp/shared-logic';
import { useCall } from '../../calls/CallProvider';

/** Shared by the profile and chat header so relocating the action keeps its gates. */
export const useCallDealer = (
  assetId: string | undefined,
  workspaceAsset: WorkspaceAsset | undefined,
  isEditPage = false
) => {
  const { account, isLoading: isAccountLoading } = useCurrentAccount();
  const { roles, isLoading: isRolesLoading } = useRoles();
  const call = useCall();
  const isEnabled = useIsFeatureEnabled(FeatureName.CommunicationPlatform);
  const assetName = workspaceAsset?.asset?.name;
  const workspaceId = workspaceAsset?.workspace?.id;
  const isGuest =
    isAccountLoading || isRolesLoading || !workspaceId
      ? true
      : isGuestWorkspaceRole(workspaceId, account?.workspaceRoles, roles);
  const canCallDealer =
    !isGuest &&
    hasAssetAccess(account, workspaceAsset) &&
    !isEditPage &&
    isEnabled &&
    !!account?.hasPermission(PermissionValues.call.create) &&
    !!call?.startAssetCall &&
    !!assetId &&
    !!assetName &&
    !!workspaceId;

  const onCallDealer = () => {
    if (!canCallDealer || !assetId || !assetName || !workspaceId) return;
    call?.startAssetCall?.({ assetId, assetName, workspaceId });
  };

  return { canCallDealer, onCallDealer };
};
